import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAdminSearch } from '../../shared/useAdminSearch';
import { BROKER_GROUP_SEARCH_OPTIONS } from '../../shared/searchOptions';
import { AdminDataGrid } from '../../shared/AdminDataGrid';
import { AdminExportButton } from '../../shared/AdminExportButton';
import { useListAllBrokerGroupsQuery } from '../api/brokerGroupsApi';
import { brokerGroupColumns, DEFAULT_HIDDEN_BROKER_GROUP_COLUMNS } from './columns';
import { useBrokerGroupFilter } from './useBrokerGroupFilter';

/**
 * The admin broker groups grid. Loads every broker group, then filters (filters, from the
 * page's toolbar: ledger and country), searches (by id, name and ledger), sorts and pages
 * them in the browser. With a search and no column sort, rows are in relevance order.
 * Export downloads the current results. Clicking a row opens its edit drawer (the
 * :brokerGroupId route), keeping the page's search.
 *
 * @param {object} props
 * @param {string} props.search from useAdminListParams
 * @param {object} props.filters from useAdminListParams
 * @param {object} props.gridProps from useAdminListParams
 */
export const BrokerGroupsTable = ({ search, filters, gridProps }) => {
	const navigate = useNavigate();
	const { search: locationSearch } = useLocation();
	const { data: brokerGroups = [], isLoading, isError } = useListAllBrokerGroupsQuery();
	const filteredBrokerGroups = useBrokerGroupFilter(brokerGroups, filters);
	const rows = useAdminSearch(filteredBrokerGroups, BROKER_GROUP_SEARCH_OPTIONS, search);

	return (
		<AdminDataGrid
			table='brokerGroups'
			columns={brokerGroupColumns}
			defaultHiddenColumns={DEFAULT_HIDDEN_BROKER_GROUP_COLUMNS}
			rows={rows}
			isLoading={isLoading}
			isError={isError}
			objectType='broker groups'
			toolbarActions={<AdminExportButton fileName='Broker_Groups' />}
			{...gridProps}
			onRowClick={({ id }) => navigate({ pathname: id, search: locationSearch })}
		/>
	);
};
